import { Map, OrderedMap } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'

const MAX_REVEAL_IPS = 50

const isRevealDataShownByIp = handleActions(
  {
    [actions.showRevealData]: (state, action) => {
      const { ip } = action.payload
      return state.set(ip, true)
    },
  },
  Map(),
)

const statusByIp = handleActions(
  {
    [combineActions(
      actions.fetchRevealDataByIpPending,
      actions.fetchRevealDataByIpSuccess,
      actions.fetchRevealDataByIpFailed,
      actions.fetchRevealDataByIpCancelled
    )]: (state, action) => {
      const { ip } = action.payload
      return state.set(ip, action.type)
    },
  },
  Map(),
)

const dataByIp = handleActions(
  {
    [actions.fetchRevealDataByIpSuccess]: (state, action) => {
      const { data, ip } = action.payload
      return state.set(ip, data).takeLast(MAX_REVEAL_IPS)
    },
  },
  OrderedMap()
)

const dataByEndUserId = handleActions(
  {
    [actions.fetchRevealDataSuccess]: (state, action) => {
      const { data, endUserId } = action.payload
      return endUserId ? state.set(endUserId, data) : state
    },
  },
  Map()
)

export default combineReducers({
  statusByIp,
  dataByIp,
  dataByEndUserId,
  isRevealDataShownByIp,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/reveal/reducer.js